// reference: https://en.wikipedia.org/wiki/List_of_HTTP_status_codes

const resCode = {
  OK: 200
}

export default resCode
